// extracted by mini-css-extract-plugin
module.exports = {"Gráficos":"Gráficos_Gráficos__3j8aH"};